var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/lock",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C10.3933535,4 9.09090909,5.34314575 9.09090909,7 L9.09090909,8.5 L14.9090909,8.5 L14.9090909,7 C14.9090909,5.34314575 13.6066465,4 12,4 M6.18181818,7 L6.18181818,8.5 C4.97683327,8.5 4,9.50735931 4,10.75 L4,19.75 C4,20.9926407 4.97683327,22 6.18181818,22 L17.8181818,22 C19.0231667,22 20,20.9926407 20,19.75 L20,10.75 C20,9.50735931 19.0231667,8.5 17.8181818,8.5 L17.8181818,7 C17.8181818,3.6862915 15.2132931,1 12,1 C8.78670691,1 6.18181818,3.6862915 6.18181818,7 M12,17.125 C12.6495738,17.125 13.2498048,16.767627 13.5745917,16.1875 C13.8993786,15.607373 13.8993786,14.892627 13.5745917,14.3125 C13.2498048,13.732373 12.6495738,13.375 12,13.375 C10.9958459,13.375 10.1818182,14.2144661 10.1818182,15.25 C10.1818182,16.2855339 10.9958459,17.125 12,17.125",
    id: "Shape",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.078d0b548aeb7d4d8fa298f3ebc11a48.svg";
export { ForwardRef as ReactComponent };